// extracted by mini-css-extract-plugin
export default {"imageWrapper":"NH-z","hovered":"OH-z","hoverImage":"PH-z","mainImage":"QH-z","imageNoBackground":"RH-z","fullSizeImage":"SH-z"};